<template>
  <div class="lz-field">
    <label class="lz-field-label" for="projectSelect">Project</label>
    <select
      id="projectSelect"
      class="form-control"
      v-model="selectedProject"
      @change="projectChanged"
      :disabled="loadingType">
      <option value="def" selected v-if="loadingType">Please wait...</option>
      <option value="def" selected v-if="!loadingType">Select one...</option>
      <option
        v-for="prj in projects"
        :key="prj.uid"
        :value="prj.code + ':' + prj.uid">
        <span v-if="prj.type === 'project'"
          >{{ prj.code }}: {{ prj.title }}</span
        >
        <span v-else>{{ prj.title }}</span>
      </option>
    </select>
  </div>
</template>

<script>
import Services from '../../services/main.service.vue'

export default {
  name: 'ProjectSelector',
  props: ['activityType'],
  data() {
    return {
      loadingType: false,
      selectedProject: 'def',
      projects: []
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    project() {
      return this.FormData.project
    }
  },
  async mounted() {
    this.projects = []
    if (!this.projects.length) {
      this.loadingType = true
      const Projects = await Services.Projects.getMondayProjects()
      this.projects = Projects.data.content
        .map((prj) => {
          const prjType = prj.type === 'business_development' ? 'BD' : 'Project'
          if (prjType === 'BD') {
            const hasBDPerfix = /^BD/.test(prj.title)
            if (!hasBDPerfix) {
              prj.title = `BD ${prj.title}`
              if (prj.client) {
                prj.title = `${prj.title} (${prj.client})`
              }
            }
          }
          return prj
        })
        .sort((a, b) => {
          if (a.title < b.title) return -1
          if (a.title > b.title) return 1
          return 0
        })
      if (this.activityType == 'exp') {
        this.projects.unshift({
          uid: 'candesic',
          code: 'CANEXP',
          title: 'Candesic Expense'
        })
      }
      this.loadingType = false
    }
  },
  methods: {
    projectChanged() {
      if (this.project !== this.selectedProject) {
        this.$store.commit('modifyFormData', {
          key: 'project',
          value: this.selectedProject
        })
      }
    }
  }
}
</script>
